// Environment Configuration
// All configuration is loaded from .env file via webpack DefinePlugin
// This file provides a unified interface to access environment variables

/**
 * Helper function to parse boolean from environment variable
 */
function parseBoolean(value, defaultValue = false) {
  if (value === undefined || value === null || value === "") {
    return defaultValue;
  }
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    return value === "true" || value === "1";
  }
  return defaultValue;
}

/**
 * Helper function to parse number from environment variable
 */
function parseNumber(value, defaultValue = null) {
  if (value === undefined || value === null || value === "") {
    return defaultValue;
  }
  if (typeof value === "number") return value;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
}

/**
 * Get environment configuration from process.env (injected by webpack DefinePlugin)
 * All values must be defined in .env file
 */
function getEnvConfig() {
  // process.env values are injected by webpack DefinePlugin at build time
  // They come from .env file loaded in config/dev.env.js and config/prod.env.js

  const config = {
    ENV_NAME: process.env.ENV_NAME || "dev",

    // API Configuration
    API_BASE_URL: process.env.API_BASE_URL || "",
    API_ENDPOINT: process.env.API_ENDPOINT || "",
    API: process.env.API || process.env.API_ENDPOINT || "",

    // WebSocket Configuration
    WS_URL: process.env.WS_URL || "",

    // Firebase Configuration
    FIREBASE_CONFIG: {
      apiKey: process.env.FIREBASE_API_KEY || "",
      authDomain: process.env.FIREBASE_AUTH_DOMAIN || "",
      databaseURL: process.env.FIREBASE_DATABASE_URL || "",
      projectId: process.env.FIREBASE_PROJECT_ID || "",
      storageBucket: process.env.FIREBASE_STORAGE_BUCKET || "",
      messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "",
    },

    // OneSignal Configuration
    ONESIGNAL_CONFIG: {
      appId: process.env.ONESIGNAL_APP_ID || "",
      apiUrl:
        process.env.ONESIGNAL_API_URL ||
        "https://onesignal.com/api/v1/notifications",
      authorization: process.env.ONESIGNAL_AUTHORIZATION || "",
      groupSize: parseNumber(process.env.ONESIGNAL_GROUP_SIZE, 200),
    },

    // Google Maps Configuration
    GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY || "",

    // Debug Configuration
    DEBUG: parseBoolean(process.env.DEBUG, false),
    LOG_API_CALLS: parseBoolean(process.env.LOG_API_CALLS, false),

    // Audio Configuration
    PAST_RUN_AUDIO_BASE_URL:
      process.env.PAST_RUN_AUDIO_BASE_URL ||
      "https://sgp1.vultrobjects.com/liverun-bucket/spreaker-live/",
  };

  // Validate required configuration
  if (!config.API_ENDPOINT && !config.API) {
    console.error(
      "❌ API_ENDPOINT or API not found in .env file. Please configure .env file."
    );
  }

  if (!config.WS_URL) {
    console.error(
      "❌ WS_URL not found in .env file. Please configure .env file."
    );
  }

  // Validate Firebase configuration
  if (!config.FIREBASE_CONFIG.apiKey || !config.FIREBASE_CONFIG.databaseURL) {
    console.error(
      "❌ Firebase configuration is missing or incomplete in .env file."
    );
    console.error("Required fields: FIREBASE_API_KEY, FIREBASE_DATABASE_URL");
    console.error("Current Firebase config:", {
      apiKey: config.FIREBASE_CONFIG.apiKey ? "SET" : "MISSING",
      authDomain: config.FIREBASE_CONFIG.authDomain ? "SET" : "MISSING",
      databaseURL: config.FIREBASE_CONFIG.databaseURL ? "SET" : "MISSING",
      projectId: config.FIREBASE_CONFIG.projectId ? "SET" : "MISSING",
      storageBucket: config.FIREBASE_CONFIG.storageBucket ? "SET" : "MISSING",
      messagingSenderId: config.FIREBASE_CONFIG.messagingSenderId
        ? "SET"
        : "MISSING",
    });
  } else {
    console.log("✅ Firebase configuration loaded successfully");
  }

  console.log(`✅ Loaded environment configuration: ${config.ENV_NAME}`);
  console.log(`🌐 API Endpoint: ${config.API_ENDPOINT || config.API}`);
  console.log(`🔌 WebSocket URL: ${config.WS_URL}`);

  return config;
}

export default getEnvConfig();



// WEBPACK FOOTER //
// ./src/config/env.js